import { SaleMenService } from '@/backend/market'
import { SalesManRepository } from '../../domain/repositories/SalesManRepository'
import { SalesManModel } from '../models/SalesManModel'
import type { SalesManEntity } from '../../domain/entities/SalesManEntity'

export class SalesManRepositoryImpl implements SalesManRepository {
  async getSalesMen(): Promise<SalesManEntity[] | { error: true }> {
    try {
      const response = await SaleMenService.getAllAdmin()

      const salesManModel = response.map((item) => new SalesManModel(item))

      return salesManModel
    } catch {
      return { error: true }
    }
  }
  async getSalesMan(id: number): Promise<SalesManEntity | { error: true }> {
    try {
      const response = await SaleMenService.getByIdAdmin({
        id
      })

      const salesManModel = new SalesManModel(response)

      return salesManModel
    } catch {
      return { error: true }
    }
  }
  async createSalesMan(name: string): Promise<{ success: true } | { error: true }> {
    try {
      await SaleMenService.createAdmin({
        requestBody: {
          name
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateSalesMan({
    id,
    name
  }: {
    id: number
    name: string
  }): Promise<{ success: true } | { error: true }> {
    try {
      await SaleMenService.updateAdmin({
        id,
        requestBody: {
          name
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteSalesMan(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await SaleMenService.deleteAdmin({
        id
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
